import * as jQuery from "jquery";
import * as React from "react";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { bookOfMindKeyboardEvents } from "source/app/services/UI/KeyboardEvents/BookOfMindKeyboardEvents";
import { HandleKeyboardEvent } from "source/app/services/UI/KeyboardEvents/WithKeyboardHotkeys";

export function HandleBookOfMindKeyboardEvents(state: IBookOfMindState) {
    React.useEffect(() => {
        jQuery("#hotkeyTarget_bookofMind")
            .off("keydown")
            .on("keydown", (event: any) => {
                HandleKeyboardEvent(bookOfMindKeyboardEvents, event);
            });
    }, [state.remainingQuotesToDisplay.length]);
}
